import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

/**
 * KPI : valeur en display serif + libellé. Valeur ≥ 22px → serif sûre (garde-fou V2).
 * `label` fourni i18n au point d'appel.
 */
export function Stat({
  value,
  label,
  hint,
  className,
}: {
  value: ReactNode
  label: ReactNode
  hint?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col gap-0.5', className)}>
      <span className="font-display text-[28px] leading-none text-[var(--v2-ink)]">{value}</span>
      <span className="text-sm font-medium text-[var(--v2-ink-2)]">{label}</span>
      {hint ? <span className="text-xs text-[var(--v2-ink-3)]">{hint}</span> : null}
    </div>
  )
}
